<template>
  <div class="freightPriceCalculator">
    <div class="title">{{ $t.calculator.title }}</div>
    <van-form
      label-width="300px"
      :show-error="false"
      :scroll-to-error="false"
      @failed="onFailed"
      @submit="onSubmit(0)"
    >
      <van-field
        class="custom-field w-33 m-r-3"
        :label="$t.calculator.packageSize"
        :placeholder="$t.calculator.length"
        v-model="form.Length"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        class="custom-field w-33 m-r-3"
        :placeholder="$t.calculator.width"
        v-model="form.Width"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        class="custom-field w-33"
        :placeholder="$t.calculator.height"
        v-model="form.Height"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
      />

      <van-field
        class="custom-field"
        :label="$t.calculator.weight"
        :placeholder="$t.calculator.input"
        v-model="form.WeightKG"
        oninput="if(isNaN(value)) { value = null } if(value.indexOf('.')>0){value=value.slice(0,value.indexOf('.')+3)}"
        required
        :rules="[
          {
            required: true,
            message: $t.calculator.input + ' ' + $t.calculator.weight,
          },
        ]"
      />

      <van-field
        class="custom-field"
        readonly
        clickable
        :value="fpid.text"
        :label="$t.calculator.col1"
        :placeholder="$t.calculator.select"
        @click="onShowFpid"
        required
        :rules="[
          {
            required: true,
            message: $t.calculator.select + ' ' + $t.calculator.col1,
          },
        ]"
      />

      <div style="padding: 10px">
        <van-button
          block
          type="info"
          color="#2750aa"
          :icon="searchIcon"
          class="search-button"
          native-type="submit"
          >{{ $t.calculator.search }}</van-button
        >
      </div>
    </van-form>

    <div class="search-top" v-if="tableList.length > 0">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="tabItem" @click="onSubmit(0)">
          <p :class="['tabItemTotal', form.OrderBy == 0 ? 'itemTopAction' : '']">
            {{ $t.calculator.orderBy1 }}
          </p>
        </van-col>
        <van-col class="tabItem" @click="onSubmit(1)">
          <p :class="['tabItemTotal', form.OrderBy == 1 ? 'itemTopAction' : '']">
            {{ $t.calculator.orderBy2 }}
          </p>
        </van-col>
      </van-row>
    </div>

    <div class="table-content">
      <calculator-table :tableList="tableList" :fpid="fpid"></calculator-table>
    </div>

    <option-list
      event="showCalculatorFreightPrice"
      :options="fpidList"
      @onSelect="onSelectFpid"
    ></option-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Row, Col, Button, Image } from "vant";
import calculatorTable from "./components/calculator-table";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Row).use(Col).use(Button).use(Image);
export default {
  name: "freightPriceCalculator",
  components: {
    calculatorTable,
    OptionList,
  },
  data() {
    return {
      searchIcon: require("@/assets/img/freightPriceCalculator/search-money.png"),
      form: {
        Length: null,
        Width: null,
        Height: null,
        WeightKG: null,
        OrderBy: 0,
      },
      fpid: { text: "", value: "" },
      fpidList: [],
      tableList: [],
    };
  },
  created() {
    this.getFreightPriceListByPage();
  },
  methods: {
    onSelectFpid(item) {
      this.fpid.text = item.text;
      this.fpid.value = item.value;
    },
    onShowFpid() {
      this.$bus.$emit("showCalculatorFreightPrice", true);
    },
    getFreightPriceListByPage() {
      this.$commonMethod.showLoading();
      var param = {};
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getFreightPriceListByPage(param)
          .then((res) => {
            this.formatFreightPrice(res.data.Data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatFreightPrice(items) {
      items.forEach((item) => {
        let data = {
          text: item.CountryName,
          image: item.NationalFlagPicture,
          value: item.FPId,
        };
        this.fpidList.push(data);
      });
    },
    onSubmit(orderBy) {
      var param = this.form;
      param.OrderBy = orderBy;
      param.FPId = this.fpid.value;
      this.$commonMethod.showLoading();
      this.$api.calculator
        .freightPriceCalculator(param)
        .then((res) => {
          this.tableList = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onFailed(errorInfo) {
      if (errorInfo && errorInfo.errors.length > 0) {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
          msg: errorInfo.errors[0].message,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.freightPriceCalculator {
  ::v-deep .van-form {
    margin: 10px;
    padding: 10px;
    box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    .van-cell__title {
      flex: unset !important;
    }
    .van-field__error-message {
      font-size: 10px !important;
    }
  }
  .search-top {
    text-align: center;
    width: 50%;
    margin-bottom: 10px;
    .search-top-row {
      width: 100%;
      text-align: center;
      .tabItem {
        width: 45%;
        text-align: center;
        font-size: 12px;
        margin-left: 5%;
        .itemTop {
          display: flex;
          display: -webkit-flex;
          align-items: center;
          -webkit-align-items: center;
          list-style: none;
          text-align: center;
          justify-content: center;
          -webkit-justify-content: center;
          .itemTopName {
            margin: 0;
            padding: 0;
          }
        }
        .tabItemTotal {
          margin: 0;
          color: #666;
          background: #f7f9fb;
          padding: 5px 10px;
          border-radius: 100px;
          border: 2px solid #e4e9f0;
        }
        .itemTopAction {
          color: #ffffff;
          background: #2750aa;
          font-weight: bold;
          border: 2px solid transparent;
        }
      }
    }
  }
  .table-content {
    height: auto;
  }
  .w-33 {
    width: 30.33% !important;
    display: inline-block !important;
  }
  .m-r-3 {
    margin-right: 4%;
  }
  ::v-deep .custom-field::before {
    left: 0px !important;
  }
  ::v-deep .custom-field::after {
    border: none !important;
  }
  .search-button {
    border-radius: 10px;
    .van-button__icon {
      line-height: 16px;
      height: 16px;
      font-size: 16px;
    }
    .van-button__text {
      font-size: 14px !important;
    }
  }
  .custom-field {
    width: auto;
    display: block;
    padding: 0px !important;
    margin-bottom: 10px;
    ::v-deep .van-field__label {
      width: auto;
      margin-left: 10px;
      margin-bottom: 10px;
      font-weight: 500;
      color: #000;
    }
    ::v-deep .van-cell__value {
      border: 2px solid #e4e9f0;
      background: #f9fafd;
      border-radius: 10px;
      padding: 10px 15px;
      .van-field__control {
        height: 20px;
        line-height: 20px;
      }
      .van-field__control::placeholder {
        font-size: 12px;
        font-weight: normal;
        color: #999 !important;
      }
    }
  }
}
</style>
